import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/app.scss'

// Axios*
import axios from './plugins/axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

// BootstrapVue
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

// Prism
import 'prismjs'
import 'prismjs/themes/prism.css'

import VuePrismEditor from 'vue-prism-editor'
import 'vue-prism-editor/dist/VuePrismEditor.css'
Vue.component('prism-editor', VuePrismEditor)

// Font Awesome
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fad } from '@fortawesome/pro-duotone-svg-icons'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
library.add(fad, fas, far, fal)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)

// FlagIcon
import FlagIcon from 'vue-flag-icon'
Vue.use(FlagIcon)

// QR Code Generator
import VueQRCodeComponent from 'vue-qr-generator'
Vue.component('qr-code', VueQRCodeComponent)

// ProgressBar
import VueProgressBar from 'vue-progressbar'
const options = {
    color: '#27AE60',
    // color: '#3498DB',
    failedColor: '#E74C3C',
    thickness: '2px',
    transition: {
        speed: '0.5s',
        opacity: '0.5s',
        termination: 300
    },
    autoRevert: true,
    // location: 'left',
    inverse: false
}
Vue.use(VueProgressBar, options)

// TextareaAutosize
import TextareaAutosize from 'vue-textarea-autosize'
Vue.use(TextareaAutosize)

// Gravatar
import Gravatar from 'vue-gravatar'
Vue.component('v-gravatar', Gravatar)

// Lodash
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
Vue.use(lodash, VueLodash)

// Multiselect
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

// VueScrollTo
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
     container: 'body',
     duration: 0,
     easing: 'ease-out',
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
})

// Sweet Alert 2
import Swal from 'sweetalert2/dist/sweetalert2.js';
import VueSweetalert2 from 'vue-sweetalert2'
Vue.use(VueSweetalert2)

// VueTippy
import VueTippy, { TippyComponent } from 'vue-tippy'
Vue.use(VueTippy, {
    animation: 'fade',
    placement: 'bottom',
    arrow: true,
    arrowType: 'round',
    flip: true,
    flipBehavior: ['bottom', 'top'],
    flipOnUpdate: true,
    // delay: [250, 0],
    hideOnClick: false
})
Vue.component('tippy', TippyComponent)

// VueClipboard
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

// VueDragDrop
import VueDragDrop from 'vue-drag-drop'
Vue.use(VueDragDrop)

// VueContentPlaceholders
import VueContentPlaceholders from 'vue-content-placeholders'
Vue.use(VueContentPlaceholders)

// VueLocalStorage
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage)

// Vue config
Vue.config.productionTip = false

Vue.directive('focus', {
    inserted (el) {
        Vue.nextTick(() => {
            el.focus()
        })
    }
})

Vue.directive('uppercase', {
    update: function (el) {
        el.value = el.value.toUpperCase()
    }
})

router.beforeEach((to, from, next) => {

    if(to.fullPath == '/redirect'){
        next({
            path: '/redirect',
            query: { redirect: to.fullPath }
        })
    }

    store.dispatch('getSession')
    .catch(error => {
        let status = null

        if (
            error.response &&
            error.response.status
        ) {
            status = error.response.status
        }

        if (
            to.matched.some(record => record.meta.requiresAuth) &&
            status == 401
        ) {
            // clear user
            store.commit('setUser', {})

            next({
                path: '/login',
                query: { redirect: to.fullPath }
            })
        }
    })

    next()
})

router.onError(error => {
    if (/ChunkLoadError:/i.test(error.message) || /Failed to load resource:/i.test(error.message)) {
        Swal.fire({
            html: 'A new version of SBP is available. Please refresh the page.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Refresh',
            confirmButtonColor: '#27AE60',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        }).then((result) => {
            if(result.isConfirmed) window.location.reload()
        })
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
